import common from '@/store/actions/common'; // 系统管理
export default {
    setSideNav: common.setSideNav,                                    // 侧边栏
    getCity: common.getCity,                                          // 获取省市县
}